<template>
  <v-data-table
    v-model="selecteds"
    :headers="headers"
    :items="classes"
    item-key="title"
    show-select
    class="elevation-1"
    :footer-props="{
      'items-per-page-text': 'Lớp mỗi trang',
      'items-per-page-all-text': 'Tất cả',
    }"
  >
    <template v-slot:[`footer.page-text`]="items">
      {{ items.pageStart }} - {{ items.pageStop }} trên tổng
      {{ items.itemsLength }}
    </template>
    <template v-slot:[`item.studentNo`]="{ item }">
      {{ item.students.filter((s) => s.status === 'active').length }}
    </template>

    <div slot="top">
      <div>
        <v-card flat class="ma-4 pa-4 elevation-0" outlined>
          <div class="d-flex">
            <AutocompleteGrade
              class="mr-2"
              v-model="grade"
              item-text="title"
              item-value="id"
              label="Khối"
              required
              dense
              outlined
              auto-select-first
              hide-details
              style="max-width: 256px"
            />
            <v-btn class="search-button" color="primary" outlined @click="search">Tìm kiếm</v-btn>
          </div>
        </v-card>
        <div class="d-flex justify-space-between ps-4 py-2">
          <span :class="selecteds.length ? 'text--primary' : 'text--disabled'">
            {{ selecteds.length ? 'Đã chọn ' + selecteds.length + ' lớp' : 'Chưa chọn' }}
          </span>
          <v-btn
            class="mr-4"
            small
            color="primary"
            :disabled="!selecteds.length"
            @click="$emit('sendPost', { classes: selecteds })"
          >
            Gửi tin nhắn
          </v-btn>
        </div>
      </div>
    </div>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import { get } from 'lodash'

export default {
  components: { AutocompleteGrade },
  data() {
    return {
      selecteds: [],
      grade: null,
      headers: [
        { text: 'Nhóm nhận tin', value: 'title' },
        // { text: 'Số lớp', value: 'classNo' },
        { text: 'Số học sinh', value: 'studentNo' },
      ],
    }
  },
  computed: {
    ...mapState('postCreate', ['classes', 'sendPostResult']),
  },
  methods: {
    ...mapActions('postCreate', ['fetchClassData']),
    search() {
      if (this.grade) {
        this.fetchClassData({ grade: get(this.grade, 'id') })
      }
    },
  },
  watch: {
    sendPostResult: {
      handler(val) {
        if (val && val.isSuccess) {
          this.selecteds = []
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped></style>
